import { Guid } from 'guid-typescript';
import { ImportFileFormData, UpdateFileFormData } from '../../component/ImportDialog/ImportDialog.types';
import { ApiUrls } from '../ApiConstants/ApiUrls';
import { FetchApi } from '../ApiFetch/ApiFetch';
import { CreateBlobResponse, CreateTextResponse, ResponseData } from '../ApiFetch/ApiResponse';
import { HTTPMethod } from '../ApiFetch/HTTPMethod.types';
import { ServiceType } from '../ApiFetch/ServiceType.types';

export const getRsmReferenceLibrary = async (): Promise<ResponseData> => {
    const url = ApiUrls.GET_RSM_REFERENCE_LIBRARY;
    const response = await FetchApi({
        endpoint: url,
        method: HTTPMethod.Get,
        apiType: ServiceType.Enrichment
    }).catch((error) => {
        return error;
    });
    return CreateTextResponse(response);
};

export const uploadRsmReferenceTableFile = async (formRequest: ImportFileFormData): Promise<ResponseData> => {
    const formData = commonFormData(formRequest);
    const url = ApiUrls.RSM_REFERENCE_LIBRARY;
    const response = await FetchApi({
        endpoint: url,
        method: HTTPMethod.Post,
        apiType: ServiceType.Enrichment,
        body: formData,
    }).catch((error) => {
        return error;
    });
    return CreateTextResponse(response);
};

export const updateRsmReferenceTableFile = async (formRequest: UpdateFileFormData): Promise<ResponseData> => {
    const url = ApiUrls.RSM_REFERENCE_LIBRARY;
    const formData = new FormData();
    formData.append('Name', formRequest.name);
    formData.append('IsActive', `${formRequest.isActive}`);
    formData.append('RsmReferenceLibraryId', `${formRequest.id}`);
    const response = await FetchApi({
        endpoint: url,
        method: HTTPMethod.Put,
        apiType: ServiceType.Enrichment,
        body: formData,
    }).catch((error) => {
        return error;
    });
    return CreateTextResponse(response);
};

export const downloadRsmReferenceTableFile = async (referenceLibraryId: string): Promise<ResponseData> => {
    const url = ApiUrls.DOWNLOAD_RSM_REFERENCE_FILE
        .replace('{id}', referenceLibraryId);
    const response = await FetchApi({
        endpoint: url,
        method: HTTPMethod.Get,
        apiType: ServiceType.Enrichment,
    }).catch((error) => {
        return error;
    });
    return CreateBlobResponse(response);
};

const commonFormData = (referenceTableImportFormData: ImportFileFormData) => {
    const formData = new FormData();
    formData.append('File', referenceTableImportFormData.file);
    formData.append('Name', referenceTableImportFormData.listName);
    formData.append('IsActive', `${referenceTableImportFormData.isActive}`);
    formData.append(
        'RsmReferenceLibraryId',
        `${referenceTableImportFormData.id === '' ? Guid.EMPTY : referenceTableImportFormData.id}`,
    );
    return formData;
};
